import { Vertical } from './Vertical';
import { Horizontal } from './Horizontal';

export const TabMenu = {
  Horizontal,
  Vertical,
};
